export enum UserRole {
    SIC = 'SIC', // Оператор СИЦ
    AC = 'AC', // Сотрудник авиакомпании
    INS = 'INS', // Проверяющий, Inspector
    CON = 'CON', // Согласователь, Conformist
    DEP_CON = 'DEP_CON', // Заместитель согласователя, Deputy Conformist
    APR = 'APR' // Утверждающий, Approval
}

export const UserRoleName = {
    [UserRole.SIC]: 'Оператор Системы',
    [UserRole.AC]: 'Сотрудник АК',
    [UserRole.INS]: 'Проверяющий',
    [UserRole.CON]: 'Согласователь',
    [UserRole.DEP_CON]: 'Зам. согласователя',
    [UserRole.APR]: 'Утверждающий'
};

export const UserRoleGroup = {
    WithAuthNumber: [UserRole.AC, UserRole.APR],
    RaUsers: [UserRole.INS, UserRole.CON, UserRole.DEP_CON, UserRole.APR]
};

export enum PagesEnum {
    search = 'search',
    users = 'users',
    tokens = 'tokens',
    statistics = 'statistics',
    airlines = 'airlines',
    airports = 'airports',
    cities = 'cities',
    subsRoutes = 'subsidized-routes',
    documentTypes = 'document-types',
    passengerTypes = 'passenger-types',
    quotaCategories = 'quota-categories',
    flightRound = 'flight-round',
    couponEdits = 'coupon-edits',
    ticketEdits = 'ticket-edits',
    productionCalendar = 'calendar',
    reports = 'reports',
    reportContracts = 'report-contracts',
    eventLog = 'event-log',
    exceedanceReport = 'exceedance-report',
    subsidyReports = 'subsidy-reports'
}

export type AuthData = {
    token: string;
    expiresIn: number;
};

export type UserInfo = {
    userId: string;
    userName: string;
    userRole: UserRole;
    airlineCode: string | null;
    airlineName: string | null;
    authorizationNumber: string | null;
    hasRightToSign: boolean;
    department: string | null;
    isGeneralManager: boolean;
};

export type TableOrder = {
    column?: string;
    direction?: 'descend' | 'ascend' | null;
};

export type SelectOption<T = FieldValueSet> = {
    value: string;
    label?: string;
    fields?: T;
    disabled?: boolean;
};

export type SelectOptions = SelectOption[];

export type SelectOptionsStatus = 'initial' | 'loading' | 'loaded';

export type SelectOptionsState = {
    options: SelectOptions;
    status: SelectOptionsStatus;
};

export type FieldValueSet = { [fieldName: string]: any };

export const monthName: { [key: number]: string } = {
    1: 'Январь',
    2: 'Февраль',
    3: 'Март',
    4: 'Апрель',
    5: 'Май',
    6: 'Июнь',
    7: 'Июль',
    8: 'Август',
    9: 'Сентябрь',
    10: 'Октябрь',
    11: 'Ноябрь',
    12: 'Декабрь'
};

export const monthSelectOptions: SelectOption[] = [
    { value: '1', label: 'Январь' },
    { value: '2', label: 'Февраль' },
    { value: '3', label: 'Март' },
    { value: '4', label: 'Апрель' },
    { value: '5', label: 'Май' },
    { value: '6', label: 'Июнь' },
    { value: '7', label: 'Июль' },
    { value: '8', label: 'Август' },
    { value: '9', label: 'Сентябрь' },
    { value: '10', label: 'Октябрь' },
    { value: '11', label: 'Ноябрь' },
    { value: '12', label: 'Декабрь' }
];

export enum SubsidyReportStatus {
    accepted_for_payment = 'accepted_for_payment',
    agreed = 'agreed',
    agreed_with_comments = 'agreed_with_comments',
    approved = 'approved',
    checked_fo = 'checked_fo',
    checked_orvp = 'checked_orvp',
    corrected_ac = 'corrected_ac',
    corrected_signed_ac = 'corrected_signed_ac',
    disbanded = 'disbanded',
    disbanded_rejected = 'disbanded_rejected',
    forming = 'forming',
    forming_rejected = 'forming_rejected',
    forming_error = 'forming_error',
    forming_error_rejected = 'forming_error_rejected',
    new = 'new',
    on_sign_ac = 'on_sign_ac',
    on_sign_ac_rejected = 'on_sign_ac_rejected',
    paid = 'paid',
    rejected_treasury = 'rejected_treasury',
    rejected_with_comments = 'rejected_with_comments',
    signed_ac = 'signed_ac'
}

export enum RaUserDepartment {
    ORVP = 'ORVP',
    FO = 'Financial'
}

export enum RaUserDepartmentName {
    ORVP = 'ОРВП',
    FO = 'Фин. отдел'
}
